import { skuService } from '@/services/skuService';
import { toFullImageUrl } from '@/utils/imageUrl';
import { useCanvasLibraryPage } from './useCanvasLibraryPage';

export interface CanvasSku {
  id: string;
  name: string;
  // Thumbnail, used by the list.
  url: string;
  // Full-size image, used when the SKU is dragged into the canvas.
  fullUrl: string;
}

// Rows come as { id, data: { image, name, ... } }, the keys the SKU table columns read. SKUListItem still
// declares the old Spanish keys, so the rows are typed locally.
interface SkuRow {
  id: string;
  data: { name: string; image: string };
}

const toCanvasSku = ({ id, data }: SkuRow): CanvasSku => ({
  id,
  name: data.name,
  url: data.image,
  fullUrl: toFullImageUrl(data.image),
});

export const useCanvasSkus = (search: string) => {
  const { items, ...page } = useCanvasLibraryPage({
    search,
    fetchPage: (params) => skuService.getSKUList(params) as unknown as Promise<{ count: number; results: SkuRow[] }>,
    toItem: toCanvasSku,
    errorMessage: 'Error al obtener los SKUs',
  });
  return { skus: items, ...page };
};
